import {
    GET_OUT_OF_COUNTRY_USER_SETTING,
    UPDATE_ACCESS_CODE,
    TOGGLE_ACCESS_CODE,
    OPEN_OUT_OF_COUNTRY_DIALOG,
    CLOSE_OUT_OF_COUNTRY_DIALOG
} from "./types";

const initialState = {
    outOfCountryUserSetting: {
        countries: {
            universal: {
                accessCode: "",
                isActive: false,
            }
        }
    },
    dialog: false,
    dialogData: null,
};

const outOfCountryUserReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_OUT_OF_COUNTRY_USER_SETTING:
            return {
                ...state,
                outOfCountryUserSetting: action.payload,
            };

        case UPDATE_ACCESS_CODE:
            return {
                ...state,
                outOfCountryUserSetting: action.payload,
            };

        case TOGGLE_ACCESS_CODE:
            return {
                ...state,
                outOfCountryUserSetting: action.payload,
            };

        case OPEN_OUT_OF_COUNTRY_DIALOG:
            return {
                ...state,
                dialog: true,
                dialogData: action.payload || null,
            };

        case CLOSE_OUT_OF_COUNTRY_DIALOG:
            return {
                ...state,
                dialog: false,
                dialogData: null,
            };

        default:
            return state;
    }
};

export default outOfCountryUserReducer;
